export default __webpack_public_path__ + "static/media/par_i_regn.5bdeb976.jpg";